/**
 * #2919 — the one-line "Tarii has an update." strip, and the page-change
 * watcher that applies a waiting update (`lib/appUpdate.ts`).
 *
 * Mounted once inside the router (`App.tsx`), so it covers the laptop
 * shell, the member app and the demo. It renders nothing until a new
 * build is waiting. A page change applies the update (unless a text field
 * has focus); the Reload button applies it at once.
 */
import { useEffect, useRef, useSyncExternalStore } from "react";
import { useLocation } from "react-router-dom";

import { applyUpdate, isUpdateReady, noteRouteChange, subscribeAppUpdate } from "../lib/appUpdate";

export function AppUpdateStrip() {
  const ready = useSyncExternalStore(subscribeAppUpdate, isUpdateReady, () => false);
  const { pathname } = useLocation();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    if (previousPathname.current === pathname) return;
    previousPathname.current = pathname;
    noteRouteChange();
  }, [pathname]);

  if (!ready) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-[60] flex justify-center px-3 pb-[calc(env(safe-area-inset-bottom)+5rem)] md:pb-4">
      <output
        data-testid="app-update-strip"
        className="motion-state-in pointer-events-auto flex items-center gap-3 rounded-md border border-border bg-bg-elevated px-3 py-2 text-sm text-fg shadow-lg"
      >
        <span>Tarii has an update.</span>
        <button
          type="button"
          onClick={applyUpdate}
          className="rounded-md bg-accent px-2.5 py-1 text-sm font-medium text-accent-fg hover:bg-accent-strong"
        >
          Reload
        </button>
      </output>
    </div>
  );
}
